export const pages = [
  {
    title: 'Bem Aqui',
    hashtag: 'BemAqui',
    url: '/',
    header: 'Juntos Somos Mais Fortes',
    description:
      'Não está fácil identificar o que está funcionando. Por isso, criamos o Bem Aqui: uma plataforma construída com você, onde é possível encontrar os estabelecimentos e serviços que estejam atendendo*.',
    description2:
      '* claro, apenas estabelecimentos autorizados legalmente a funcionar (presencialmente ou por entrega).',
    shareMessage: '{0} no %23BemAqui %23RPC',
    shareMessageTwitter: '{0} no BemAqui!',
    palette: {
      dark: '#002a4a',
      main: '#006697',
      light: '#b0ddff',
    },
    idCategoriaEnvio: 10,
    segmentos: [
      {
        id: 1,
        nome: 'Alimentos e Bebidas',
      },
      {
        id: 2,
        nome: 'Materiais de Construção',
      },
      {
        id: 3,
        nome: 'Loja de Tecidos e Aviamentos',
      },
      {
        id: 4,
        nome: 'Loja de Departamentos',
      },
      {
        id: 5,
        nome: 'Floricultura, Paisagismo e Jardinagem',
      },
      {
        id: 6,
        nome: 'Óticas, Relojoarias, Joalherias e Perfumaria',
      },
      {
        id: 7,
        nome: 'Bancas, Papelarias e Embalagens',
      },
      {
        id: 8,
        nome: 'Informática',
      },
      {
        id: 9,
        nome: 'Loja de Roupas e Calçados',
      },
      {
        id: 10,
        nome: 'Saúde e Bem-estar',
      },
      {
        id: 11,
        nome: 'Supermercados e Mercearia',
      },
      {
        id: 12,
        nome: 'Academia',
      },
      {
        id: 13,
        nome: 'Casa e Decoração',
      },
      {
        id: 14,
        nome: 'Bancos e Lotéricas',
      },
      {
        id: 15,
        nome: 'Borracharia e Oficinas Mecânicas',
      },
      {
        id: 16,
        nome: 'Loja de Carros',
      },
      {
        id: 17,
        nome: 'Turismo',
      },
      {
        id: 18,
        nome: 'Beleza',
      },
      {
        id: 19,
        nome: 'Educação',
      },
      {
        id: 20,
        nome: 'Agricultura',
      },
      {
        id: 21,
        nome: 'Outros',
      },
    ],
  },
]
